import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, filter, Observable, take } from "rxjs";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { ResponseInfo } from "./model/response-info.model";
import { ErrorHandlerService } from "../error-handler/error-handler.service";
import { JwtService } from "./jwt.service";
import { environment } from "../../../../environments/environment";

@Injectable({ providedIn: "root" })
export class AuthService {
	private readonly httpBackend = inject(HttpBackend);
	private readonly jwtService = inject(JwtService);
	private readonly errorHandlerService = inject(ErrorHandlerService);

	private readonly AZURE_PROVIDER = "azure";
	private readonly refreshSubject = new BehaviorSubject<string | undefined>(undefined);

	private refreshing = false;

	refreshToken(): Observable<string> {
		if (!this.refreshing) {
			this.refreshing = true;
			const backendHttp = new HttpClient(this.httpBackend);
			const sso = this.jwtService.getCognitoProviderNameFromToken() === this.AZURE_PROVIDER;

			backendHttp
				.post<ResponseInfo>(environment.apiCommonUrl + "/auth/refresh", {
					refreshToken: this.jwtService.getCurrentRefreshToken(),
					sso
				})
				.subscribe({
					next: response => {
						this.jwtService.setTokensFromResponse(response);

						this.refreshing = false;
						this.refreshSubject.next(response.idToken);
					},
					error: error => {
						this.errorHandlerService.showError(error, "Failed to refresh the token");

						this.refreshing = false;
						this.refreshSubject.error("Unable to refresh token");

						// Logout
						this.jwtService.removeToken();
						location.reload();
					}
				});
		}

		return this.refreshSubject.asObservable().pipe(
			filter(token => token !== undefined),
			take(1)
		);
	}
}
